// extracted by mini-css-extract-plugin
export default {"image":"style__image___DSA2s","container":"style__container___xWwau","video":"style__video___QB_00","img":"style__img___XS4sK","imgBg":"style__imgBg___vI66G"};